import { CalendarMonth, CardMembership, Edit, Email, Person } from "@mui/icons-material";
import { Divider, Grid, IconButton, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Loading from "../../../components/layouts/Loading";
import Page from "../../../components/layouts/Page";
import { deleteElement, getElement } from "../../../database/API";
import { useSnackbar } from "notistack";
import Pill from "../../../components/layouts/Pill";
import theme from "../../../theme";
import DialogEditClient from "../../../components/form/DialogEditClient";
import { makeStyles } from "@mui/styles";
import CustomButtonAdmin from "../../../components/form/CustomButtonAdmin";
import moment from "moment/min/moment-with-locales";
import { DialogEliminar } from "../../../components/form/DialogEliminar";
import DialogEditData from "../../../components/form/DialogEditData";

const ReservaSingle = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [reserva, setReserva] = useState([]);
    const { key } = useParams();
    const [openEdit, setOpenEdit] = useState(false);
    const [openEditData, setOpenEditData] = useState(false);
    const [valueClient, setValueClient] = useState("");
    const [label, setLabel] = useState("");
    const [name, setName] = useState("");
    const [update, setUpdate] = useState(0);
    const [openEliminar, setOpenEliminar] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        const obtenir = async () => {
            setLoading(true);
            const { result } = await getElement("reserves", key);
            setReserva(result);
            setLoading(false);
        };
        obtenir();
    }, [key, update]);

    const editClient = (id, label, name, value) => {
        setLabel(label);
        setName(name);
        setValueClient(value);
        if (name === "data") {
            setOpenEditData(true);
        } else {
            setOpenEdit(true);
        }
    };

    const reenviar = async () => {
        setLoading(true);
        await getElement("reenviarCorreu", key);
        enqueueSnackbar("Correu reenviat", {
            variant: "success",
        });
        setUpdate(true);
        setLoading(false);
    };

    const eliminar = async () => {
        setLoading(true);
        setOpenEliminar(false);
        await deleteElement("reserves", key);
        enqueueSnackbar("Reserva eliminada", {
            variant: "success",
        });
        setLoading(false);
        navigate("/admin/reserves");
    };

    useEffect(() => {
        const get = async () => {
            const { result } = await getElement("reserves", key);
            setReserva(result);
            setLoading(false);
        };

        get();
    }, [key]);

    return (
        <Page title="Merolla de Berguedà">
            <Box m={5}>
                <Loading loading={loading}>
                    <Grid container spacing={2}>
                        <Grid item md={3} xs={12}>
                            <Pill title={reserva?.id} icon={<CardMembership />} label="ID" color={theme.color.primary} />
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Pill title={reserva?.nom + " " + reserva?.cognoms} icon={<Person />} label="Nom" color={theme.color.primary} />
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Pill title={reserva?.email} icon={<Email />} label="E-mail" color={theme.color.primary} />
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Pill
                                title={moment(reserva?.created_at).locale("ca").format("LLL")}
                                icon={<CalendarMonth />}
                                label="Data creació"
                                color={theme.color.primary}
                            />
                        </Grid>
                    </Grid>
                    <Grid spacing={3} container mt={2}>
                        <Grid item md={4} xs={12}>
                            <Box className={classes.bloc} mb={3}>
                                <Typography variant="h5" mb={2}>
                                    Informació Client
                                </Typography>
                                <Divider />
                                <Detall title="Nom" text={reserva?.nom} edit onClick={() => editClient(reserva?.id, "Nom", "nom", reserva?.nom)} />
                                <Detall
                                    title="Cognoms"
                                    text={reserva?.cognoms}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Cognoms", "cognoms", reserva?.cognoms)}
                                />
                                <Detall
                                    title="Telèfon"
                                    text={reserva?.telefon}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Telèfon", "telefon", reserva?.telefon)}
                                />
                                <Detall title="E-mail" text={reserva?.email} edit onClick={() => editClient(reserva?.id, "E-mail", "email", reserva?.email)} />
                                <Detall
                                    title="Preu"
                                    text={Number(reserva?.preu) + " €"}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Preu", "preu", reserva?.preu)}
                                />
                                {/* <Detall title="Estat" text={<Estat estat={reserva?.estat} change id={reserva?.unique_id} />} /> */}
                            </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <Box className={classes.bloc} mb={3}>
                                <Typography variant="h5" mb={2}>
                                    Informació Reserva
                                </Typography>
                                <Divider />
                                <Detall title="Activitat" text={reserva?.activitat?.nom} />
                                <Detall
                                    title="Data reserva"
                                    text={moment(reserva?.data).format("LL")}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Data", "data", reserva?.data)}
                                />
                                <Detall
                                    title="Adults"
                                    text={reserva?.adults}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Adults", "adults", reserva?.adults)}
                                />
                                <Detall
                                    title="Nens entre 3/7 i 12"
                                    text={reserva?.nens}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Nens entre 3/7 i 12", "nens", reserva?.nens)}
                                />
                                <Detall
                                    title="Nens entre 4 i 6"
                                    text={reserva?.nadons}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Nens entre 4 i 6", "nadons", reserva?.nadons)}
                                />
                                <Detall
                                    title="Menys de 2/3 anys"
                                    text={reserva?.bebes}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Menys de 2/3 anys", "bebes", reserva?.bebes)}
                                />
                                <Detall
                                    title="Persones (excepte bebès)"
                                    text={reserva?.total}
                                    edit
                                    onClick={() => editClient(reserva?.id, "Persones", "total", reserva?.total)}
                                />
                                {reserva?.observacions && (
                                    <Detall
                                        title="Observacions"
                                        text={reserva?.observacions}
                                        edit
                                        onClick={() => editClient(reserva?.id, "Observacions", "observacions", reserva?.observacions)}
                                    />
                                )}
                            </Box>
                        </Grid>
                        <Grid item md={4} xs={12}>
                            <Box className={classes.bloc} mb={3}>
                                <Typography variant="h5" mb={2}>
                                    Accions
                                </Typography>
                                <Divider />
                                <Stack spacing={2} direction={"row"}>
                                    <CustomButtonAdmin color="primary" onClick={() => reenviar()} fullWidth title={"Reenviar E-mail"} />
                                    <CustomButtonAdmin color="primary" onClick={() => setOpenEliminar(true)} fullWidth title={"Eliminar reserva"} />
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>
                </Loading>
                <DialogEditClient id={key} name={name} label={label} setOpen={setOpenEdit} open={openEdit} setUpdate={setUpdate} value={valueClient} />
                <DialogEditData
                    id={key}
                    name={name}
                    label={label}
                    setOpen={setOpenEditData}
                    open={openEditData}
                    setUpdate={setUpdate}
                    value={valueClient}
                    reserva={reserva}
                />
                <DialogEliminar open={openEliminar} setOpen={setOpenEliminar} element={"reserva"} onClick={eliminar} />
            </Box>
        </Page>
    );
};

export default ReservaSingle;

function Detall({ title, text, edit, onClick }) {
    const classes = useStyles();
    return (
        <Box className={classes.detall} justifyContent={"space-between"}>
            <Box>
                <Typography variant="h6" fontSize={16} color="secondary">
                    {title}
                </Typography>
                <Typography variant="body2" color="black" letterSpacing={0}>
                    {text}
                </Typography>
            </Box>
            {edit && (
                <IconButton onClick={onClick}>
                    <Edit />
                </IconButton>
            )}
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    bloc: {
        backgroundColor: theme.color.background,
        padding: 20,
        borderRadius: 10,
    },
    detall: {
        display: "flex",
        alignItems: "center",
        padding: 10,
    },
    linia: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        padding: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
}));
